import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as FileSaver from 'file-saver';
import { DxFileUploaderComponent } from 'devextreme-angular';
import * as XLSX from 'xlsx';
import { CoalService } from 'app/services/coal.service';
import { Workbook } from 'exceljs';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState, selectOperacionState } from 'app/store/app.states';

@Component({
  selector: 'app-carga-masiva',
  templateUrl: './carga-masiva.component.html',
  styleUrls: ['./carga-masiva.component.scss']
})
export class CargaMasivaComponent implements OnInit {
  @ViewChild('fileUploader', { static: false }) fileUploader: DxFileUploaderComponent;
  message: string = '';
  data: any;
  columnasExcel: any;
  frmCarga: FormGroup;
  btnUpload: boolean = false;
  columns: any;
  msgErrorId = '';
  public filename!: string;
  msgErrorServidor = '';
  formDinamico: any = []
  resultsets: any = [];
  arrayCatalogos: any;

  public indexActive: number = 0;
  public btnNextEnable: boolean = false;

  @Input('urlTemplate') urlTemplate: string = '';
  @Input('columnas') columnasTemplate: any;
  @Input('urlApi') urlApi: string = '';
  @Input('urlApiCatalogo') urlApiCatalogo: string = '';
  @Input('parametrosSP') parametrosSP: string = '';
  @Input('fuente') fuente: any;
  @Output('response') reponse = new EventEmitter<{}>();
  @Input('acciones') acciones: any;
  idTipoAccion: string = '';

  IFileUploadLabels = {
    btnSubmit: 'Cargar'
  };

  private arrayContentFile: any[] = [];

  // PASO 2

  arrayRowsFinal: any = [];
  arrayRowsFinalErrors: any = [];
  arrayProcesado: any = [];
  arrayProcesadoErrors: any = [];
  arrayProcesadoColumns: any = [];

  public process = [{
    active: true,
    finish: false,
    enabled: true
  }, {
    active: false,
    finish: false,
    enabled: false
  }, {
    active: false,
    finish: false,
    enabled: false
  }];

  idRoll = 2;
  subscribeOperacion: any;
  getStateOperacion: Observable<any>;
  idOperacion: number;



  constructor(
    private fb: FormBuilder,
    private srvcoal: CoalService,
    private readonly store: Store<AppState>,
  ) {
    this.fb = new FormBuilder();
    this.frmCarga = this.fb.group({
      'titulo': [null, Validators.required],
      'descripcion': [null],
    });
  }

  ngOnInit(): void {
    this.getStateOperacion = this.store.select(selectOperacionState);
    this.subscribeOperacion = this.getStateOperacion.subscribe((operacion) => {
      this.idOperacion = operacion.idOperacion;
  });
    this.idTipoAccion = this.acciones[0];
    this.columns = [
      {
        dataField: 'fila',
        caption: 'Fila'
      },
      {
        dataField: 'error',
        caption: 'Detalle del error'
      }
    ];
  }

  active(index: number) {
    if ((this.process[index].enabled)) {
      if (index < this.process.length) {
        this.indexActive = index;
        this.process.forEach((element, i) => {
          this.process[i].active = false;
        });
        this.process[this.indexActive].active = true;

        this.validateInputsRequired();

      }
    }

  }

  receiveMessage($event: any): void {
  }

  downloadTemplate(): void {
    let catalogos;
    if (this.fuente === 'productos') {
      this.srvcoal.getService(this.urlApiCatalogo + '?fuente=' + this.fuente).subscribe((res: any) => {
        if (res.error == "") {
          catalogos = res.recordsets;

          this.exportAsExcel(catalogos);
          // FileSaver.saveAs(this.urlTemplate, 'template.xlsx');
        } else {
          this.arrayProcesadoErrors = res.recordsets[0];
          this.msgErrorServidor = res.error;
          this.resultsets = res.recordsets[0];
        }
      }, (error: any) => {
        console.log(error);

        this.msgErrorServidor = 'Ocurrió en error al procesar el archivo';
      });

    } else {
      FileSaver.saveAs(this.urlTemplate, 'template.xlsx');
    }

  }

  async exportAsExcel(catalogos) {
    // let data = this.columnasTemplate.map(function (ele) {
    //   return { [ele.nombre]: '' };
    // })
    // const worksheet = XLSX.utils.json_to_sheet(data);
    // const workbook = XLSX.utils.book_new();

    // XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // catalogos.forEach((element, index) => {
    //   let indexNuevo = index + 2
    //   const worksheetNuevo = XLSX.utils.json_to_sheet(element);
    //   XLSX.utils.book_append_sheet(workbook, worksheetNuevo, 'Sheet' + indexNuevo.toString());
    // });

    // // Cambia 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' por 'application/vnd.ms-excel' si deseas descargar en formato .xls (Excel 97-2003)
    // XLSX.writeFile(workbook, this.fuente + '.xlsx', { bookType: 'xlsx', type: 'buffer' });


    // var options = {
    //   filename: './streamed-workbook.xlsx',
    //   useStyles: true,
    //   useSharedStrings: true
    // };
    let workbook = new Workbook();

    let worksheet = workbook.addWorksheet('Sheet');

    worksheet.columns = this.columnasTemplate.map(function (ele) {
      return { header: ele.nombre, width: 15, style: { font: { color: { argb: ele.obligatorio ? 'FA130B' : '0A0909' } } } };
    })

    let nombresCatalogo = catalogos[0];

    catalogos.forEach((element, index) => {
      if (index > 0) {
        let indexNuevo = 'nombre' + (index).toString()
        let worksheet = workbook.addWorksheet(nombresCatalogo[0][indexNuevo]);
        let headers = Object.keys(element[0]);

        worksheet.columns = headers.map(function (ele) {
          return { header: ele, key: ele, width: 15 };
        })

        worksheet.addRows(element);
      }

    });


    let fileName = this.fuente + ".xlsx";
    const excelBuffer: any = workbook.xlsx.writeBuffer();
    workbook.xlsx.writeBuffer()
      .then(function (buffer) {
        // done buffering
        const data: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        FileSaver.saveAs(data, fileName);
      });

  }

  SubmitInputFile(fileUploader: DxFileUploaderComponent) {

    let file = fileUploader.value[0];
    var reader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      let bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      /* grab first sheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* save data */
      this.data = XLSX.utils.sheet_to_json(ws, {
        header: 1, raw: false, dateNF: 'yyyy/mm/dd'

      });
      this.data = this.data.filter(arr => !this.isElementEmpty(arr));
      this.filename = file.name
      this.message = 'Documento Cargado ' + this.filename
      this.ValidacionPasoUno()

    };
    reader.readAsBinaryString(file);

  }

  isElementEmpty(arr: any): boolean {
    return arr.every(value => value === '');
  }

  onValueChanged = (e: any, fileUploader: DxFileUploaderComponent) => {

    this.btnUpload = false;

  }

  ValidacionPasoUno() {
    this.columnasExcel = [];

    this.arrayContentFile = this.data.filter((row: any) => {
      return (row.length > 0);
    });

    const readExcel = this.data[0];
    readExcel.forEach((element: any, index: any) => {
      this.columnasExcel.push({ descripcion: element, seleccionado: false, indexColumnaTemplate: null, indexExcel: index });
    });

    this.btnNextEnable = this.columnasExcel.length > 0 ? true : false;
  }

  previous(): void {
    this.indexActive = this.indexActive == this.process.length ? (this.process.length - 1) : this.indexActive;
    if (this.indexActive > 0) {


      this.process[this.indexActive].active = false;
      this.indexActive--;
      this.process[this.indexActive].active = true;

      this.validateInputsRequired();

    }

    if (this.indexActive == 0) {
      this.fileUploader.value = [];
      this.msgErrorServidor = '';
      this.arrayRowsFinalErrors = [];
      this.arrayCatalogos = [];
      this.arrayProcesado = [];
      this.message = '';
    }
  }

  finalizar() {
    this.process[2].finish = true;
    this.reponse.emit({ error: null, excepciones: null, recordsets: this.arrayRowsFinal, message: this.msgErrorServidor, result: this.resultsets });
  }

  next(): void {
    this.btnNextEnable = false;
    if (this.indexActive < this.process.length) {
      this.process[this.indexActive].active = this.indexActive < (this.process.length - 1) ? false : true;
      this.process[this.indexActive].finish = true;
      this.indexActive++;
      if (this.indexActive < (this.process.length)) {
        this.process[this.indexActive].active = true;
        this.process[this.indexActive].enabled = true;

        this.validateInputsRequired();
        if (this.indexActive === 1) {
          this.bindigColTemplateColExcel();
          // GENERAMOS EL ARRAY DE SALIDA FINAL
          this.ResponseArray(this.arrayRowsFinal);
          this.validateInputsRequired();
        }
        if (this.indexActive === 2) {
          this.ValidarTipoAccion();
        }
      }

    }
  }

  bindigColTemplateColExcel() {
    this.arrayRowsFinal = [];
    this.arrayRowsFinalErrors = [];
    let arrayRows = [];
    const arrayContent = this.arrayContentFile;


    this.columnasExcel.forEach((columnaExcel: any, index: any) => {
      columnaExcel.indexColumnaTemplate = index;
      columnaExcel.seleccionado = true;
      arrayRows = [];
      if (columnaExcel.indexColumnaTemplate != null && columnaExcel.seleccionado) {

        const colTemplate = this.columnasTemplate[columnaExcel.indexColumnaTemplate].nombre;

        let arrayColumn = [];
        /**
         * Empezamos a recorrer las filas del excel, en el indice 0 están los titulos de columna, entonces empezamos desde la fila 1
         */
        for (let index = 1; index < arrayContent.length; index++) {

          const rowValuesExcel = arrayContent[index];

          /**
           * Validamos si vacios y tipo de dato
           */
          const responseValidate = this.validateDatas(this.columnasTemplate[columnaExcel.indexColumnaTemplate],
            rowValuesExcel[columnaExcel.indexExcel], columnaExcel.descripcion);

          if (responseValidate.isValid) {
            const row = {
              error: null, value: responseValidate.value, fila: index + 1, columnExcel: columnaExcel.indexExcel + 1
            };
            arrayColumn.push(row);
          } else {
            const row =
              { error: responseValidate.error, value: null, fila: index + 1, columnExcel: columnaExcel.indexExcel + 1 };
            arrayColumn.push(row);
            this.arrayRowsFinalErrors.push(row);

          }

        }
        /**
         * Guardamos las columnas con las validaciones, esto se hace columna por columna
         */
        if (arrayColumn.length > 0) {
          const columnJson = '{ "' + colTemplate + '": ' + JSON.stringify(arrayColumn) + ' }';
          arrayRows.push(JSON.parse(columnJson));
        }
      }
      /**
       * Guardamos la fila con las columnas en el arrayRowFinal.
       */
      if (arrayRows.length > 0) {
        this.arrayRowsFinal.push(arrayRows[0]);
      }

    });


  }

  validateDatas(columnasTemplate: any, valuesExcel: any, columnaExcel: string) {

    try {
      /**Validar cuando es obligatorio */
      if (columnasTemplate.obligatorio && (valuesExcel != undefined && valuesExcel != null && valuesExcel !== "")) {
        /** Validar tipo de dato */
        const type = typeof valuesExcel;
        /**
         * Validamos si se puede convertir el valor al tipo de dato que esperamos en el template
         */
        const parseData: any = this.parseData(columnasTemplate, type, valuesExcel, columnaExcel, columnasTemplate.obligatorio);
        if (parseData.isValid) {
          return { isValid: true, value: parseData.value, error: null };
        } else {
          return { isValid: false, value: null, error: parseData.value };
        }
        /**Cuando no es obligatorio */
      } else if (!columnasTemplate.obligatorio) {
        const type = null;
        const parseData: any = this.parseData(columnasTemplate, type, valuesExcel, columnaExcel, columnasTemplate.obligatorio);
        if (parseData.isValid) {
          return { isValid: true, value: parseData.value, error: null };
        } else {
          return { isValid: false, value: null, error: parseData.value };
        }
      } else {
        return { isValid: false, error: 'Error al intentar asignar valor a ' + columnasTemplate.descripcion + ', este campo es obligatorio, revisar la columna ' + columnaExcel + ' del excel cargado.' };
      }
    } catch (error) {
      if (!valuesExcel && !columnasTemplate.obligatorio) {
        return { isValid: true, value: valuesExcel, error: null };;
      } else {
        return { isValid: false, error: 'Error al intentar asignar valor a ' + columnasTemplate.descripcion + ', este campo es obligatorio, revisar la columna ' + columnaExcel + ' del excel cargado.' };
      }
    }
  }

  parseData(column: any, type: any, valueExcel: any, columnaExcel: any, obligatorio: any) {

    if (column.tipo == type) {
      if (type == 'string') {
        return valueExcel.length <= column.longitud ? { isValid: true, value: valueExcel } : { isValid: false, value: 'Error al intentar asignar valor a ' + column.descripcion + ': Para esta columna se espera una cadena con longitud (' + column.longitud + ') y (' + valueExcel + ') excede lo maximo permitido, revisar la columna ' + columnaExcel + ' del excel cargado.' };
      } else {
        return { isValid: true, value: valueExcel };
      }
    } else {
      try {
        switch (column.tipo) {
          case 'string':
            if (obligatorio || valueExcel) {
              if (String(valueExcel)) {
                return String(valueExcel).length <= column.longitud ? { isValid: true, value: String(valueExcel) } : { isValid: false, value: 'Error al intentar asignar valor a ' + column.descripcion + ': Para esta columna se espera una cadena con longitud (' + column.longitud + ') y (' + valueExcel + ') excede lo maximo permitido, revisar la columna ' + columnaExcel + ' del excel cargado.' };
              } else {
                return { isValid: false, value: 'Error al intentar asignar valor a ' + column.descripcion + ': Para esta columna se espera una cadena y no es posible asignar(' + valueExcel + ') como valor, revisar la columna ' + columnaExcel + ' del excel cargado.' };
              }
            } else {
              return { isValid: true, value: null }
            }
          case 'number':
            if (obligatorio || valueExcel) {
              if (valueExcel == '0') {
                return { isValid: true, value: 0 }
              } else {
                return parseInt(valueExcel) ? { isValid: true, value: parseInt(valueExcel) } : { isValid: false, value: 'Error al intentar asignar valor a ' + column.descripcion + ': Para esta columna se espera un numero y no es posible asignar(' + valueExcel + ') como valor, revisar la columna ' + columnaExcel + ' del excel cargado.' };
              }
            } else {
              return { isValid: true, value: null }
            }
          case 'Float':
            if (obligatorio || valueExcel) {
              let valInt = type == 'number' ? valueExcel + '.00' : valueExcel;

              return parseFloat(valInt) >= 0 ? { isValid: true, value: parseFloat(valInt) } : { isValid: false, value: 'Error al intentar asignar valor a ' + column.descripcion + ': Para esta columna se espera un numero decimal y no es posible asignar(' + valInt + ') como valor, revisar la columna ' + columnaExcel + ' del excel cargado.' };
            } else {
              if (valueExcel == 0) {
                let valInt = type == 'number' ? valueExcel + '.00' : valueExcel;

                return parseFloat(valInt) >= 0 ? { isValid: true, value: parseFloat(valInt) } : { isValid: false, value: 'Error al intentar asignar valor a ' + column.descripcion + ': Para esta columna se espera un numero decimal y no es posible asignar(' + valInt + ') como valor, revisar la columna ' + columnaExcel + ' del excel cargado.' };
              } else {
                return { isValid: true, value: null }
              }
            }

          default:
            return { isValid: false, value: null };
            break;
        }
      } catch (error) {
        return { isValid: false, value: 'Error al intentar asignar valor a ' + column.descripcion + ': Para esta columna se espera una fecha y no es posible asignar(' + valueExcel + ') como valor, revisar la columna ' + columnaExcel + ' del excel cargado.' }
      }
    }
  }

  ResponseArray(resp: any) {
    this.arrayProcesado = [];
    this.arrayProcesadoColumns = [];
    resp.forEach((f: any) => {
      // tslint:disable-next-line: forin
      for (const key in f) {
        f[key].forEach((item: any, index: number) => {
          const cur: any = this.arrayProcesado.filter((filtro: any) => filtro.index === index);
          if (cur.length > 0) {
            cur[0][key] = item.value;
          } else {
            const tmp: any = { index };
            tmp[key] = item.value;
            this.arrayProcesado.push(tmp);

          }
        });
      }

    });


    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < resp.length; i++) {
      Object.keys(resp[i]).forEach(key => {
        //Buscamos la descripcion de la propiedad en las columnas del template para agregar como descripcion en el datagrid
        const descripcion = this.columnasTemplate.find((columna: any) => columna.nombre === key).descripcion;
        this.arrayProcesadoColumns.push({ caption: descripcion, dataField: key });
      });

    }


    if (this.fuente == 'productos') {

      let xmlProductos = '<productos>'

      this.arrayProcesado.forEach((producto: any) => {
        xmlProductos += '<producto>'
        xmlProductos += '<index>' + producto.index.toString() + '</index>'
        xmlProductos += '<nombreInterno>' + producto.nombreInterno.toString() + '</nombreInterno>'
        xmlProductos += '<noIdentificacion>' + producto.noIdentificacion.toString() + '</noIdentificacion>'
        xmlProductos += '<precioUnitario>' + producto.precioUnitario.toString() + '</precioUnitario>'
        xmlProductos += '<descripcion>' + producto.descripcion.toString() + '</descripcion>'
        xmlProductos += '<iva>' + producto.iva.toString() + '</iva>'
        xmlProductos += '<ivaRet>' + producto.ivaRet.toString() + '</ivaRet>'
        xmlProductos += '<IEPSTasa>' + producto.IEPSTasa.toString() + '</IEPSTasa>'
        xmlProductos += '<IEPSCuota>' + producto.IEPSCuota.toString() + '</IEPSCuota>'
        xmlProductos += '<IEPSTasaCat>' + producto.IEPSTasaCat.toString() + '</IEPSTasaCat>'
        // xmlProductos += '<IEPSCuotaCuot>' + producto.IEPSCuotaCuot.toString() + '</IEPSCuotaCuot>'
        xmlProductos += '<ISR>' + producto.ISR.toString() + '</ISR>'
        xmlProductos += '<claveProdServ>' + producto.claveProdServ.toString() + '</claveProdServ>'
        xmlProductos += '<claveUnidadMedida>' + producto.claveUnidadMedida.toString() + '</claveUnidadMedida>'
        xmlProductos += '<ObjetoImpuesto>' + producto.ObjetoImpuesto.toString() + '</ObjetoImpuesto>'

        xmlProductos += '</producto>'
      });

      xmlProductos += '</productos>';

      let body = {
        xmlProductos: xmlProductos
      }


      this.srvcoal.postService('catalogo/CatalogoProducto', body).subscribe((res: any) => {
        if (res.error == "") {
          this.arrayCatalogos = res.recordsets[0];

          if (this.arrayProcesado > this.arrayCatalogos) {
            let diferencia = this.arrayProcesado.length - this.arrayCatalogos.length;
            this.msgErrorServidor += 'No se cargaran ' + diferencia.toString() + ' filas porque los valores de catálogo ingresados no existen en sistema';
          } else {
            this.msgErrorServidor += '';
          }
          // this.resultsets = res.recordsets[0];
        } else {
          this.arrayProcesadoErrors = res.recordsets[0];
          this.msgErrorServidor = res.message;
          // this.resultsets = res.recordsets[0];
        }
      }, (error: any) => {
        console.log(error);

        this.msgErrorServidor = 'Ocurrió en error al procesar el archivo';
      });
    }

    else {
      this.arrayCatalogos = this.arrayProcesado;
    }

  }

  onRowPrepared(e: any) {
    // if (e.rowType === "data") {
    //   if (e.rowElement.className == 'dx-row dx-data-row dx-row-lines dx-row-alt') {
    //     e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
    //     e.rowElement.style.backgroundColor = "#FCF4EF"

    //   }

    // }
  }

  validateInputsRequired() {
    this.msgErrorId = '';
    switch (this.indexActive) {
      case 0:
        this.btnNextEnable = this.filename == '' ? false : true;
        break;
      case 1:
        this.btnNextEnable = true;
        this.columnasTemplate.forEach((template: any, index: any) => {
          if (template.obligatorio) {
            const found = this.columnasExcel.find((element: any) => element.indexColumnaTemplate == index);

          }
        });

        break;
      case 2:
        this.btnNextEnable = this.arrayRowsFinalErrors.length === 0 ? true : false;
        break;
    }

  }

  onExporting(e: any) {

  }

  contentReady = (e: any) => {

  };

  ValidarTipoAccion() {
    this.msgErrorId = '';
    this.formDinamico = [];
    this.Guardar();
  }

  Guardar() {
    // this.spinner = true;
    this.formDinamico = [];

    for (let i = 0; i < this.arrayProcesado.length; i++) {
      let id = 0;
      Object.keys(this.arrayProcesado[i]).forEach(key => {
        const value = this.arrayProcesado[i][key];
        if (key !== 'index') {
          this.formDinamico.push({ propiedadDesc: key, valor: value, fechaCaducidad: null, id });
        } else {
          id = value;
        }
      });

    }

    let xmlFormDinamico = '<datos>'
    let index: undefined;

    if (this.fuente != 'productos') {

      if (this.formDinamico.length > 0) {
        this.formDinamico.forEach((element: any) => {
          if (element.id !== index && index !== undefined) {
            xmlFormDinamico += '</dato>'
          }
          if (element.id == undefined || element.id !== index) {
            xmlFormDinamico += '<dato>'
            index = element.id;
            xmlFormDinamico += '<index>' + element.id.toString() + '</index>'
          }
          xmlFormDinamico += '<' + element.propiedadDesc + '>' + element.valor.toString() + '</' + element.propiedadDesc + '>'

        })
      }

      xmlFormDinamico += '</dato></datos>';



      let body = {
        xmlFormDinamico: xmlFormDinamico,
        idTipoAccion: this.idTipoAccion
      }

    } else {

      let body = {}
      let id = 0;



      if (this.formDinamico.length > 0) {

        this.formDinamico.forEach((element: any, index: number) => {

          if (id == element.id) {

            if (element.propiedadDesc == 'IEPSCuota' || element.propiedadDesc == 'IEPSTasa') {
              body[element.propiedadDesc] = element.valor ? element.valor : 0;
            } else {

              body[element.propiedadDesc] = element.valor ? element.valor : '';
            }

          } else {

            body['idRol'] = this.idRoll;
            body['idOperacion'] = this.idOperacion;
            body['XMLImpuestoLocal'] = '<propiedades></propiedades>'
            body['XMLInformacionAduanera'] = '<propiedades></propiedades>'
            this.srvcoal.postService(this.urlApi, body).subscribe((res: any) => {
              if (res.error == "") {
                this.arrayProcesadoErrors = [];
                this.msgErrorServidor = '';
                this.resultsets = res.recordsets[0];


              } else {
                this.arrayProcesadoErrors = res.recordsets[0];
                this.msgErrorServidor = res.message;
                this.resultsets = res.recordsets[0];
              }
            }, (error: any) => {
              console.log(error);

              this.msgErrorServidor = 'Ocurrió en error al procesar el archivo';
            });


            body = {};
            id = id + 1;
            if (element.propiedadDesc == 'IEPSCuota' || element.propiedadDesc == 'IEPSTasa') {
              body[element.propiedadDesc] = element.valor ? element.valor : 0;
            } else {
              body[element.propiedadDesc] = element.valor ? element.valor : '';
            }
          }


          if (this.formDinamico.length == index + 1) {
            body['idRol'] = this.idRoll;
            body['idOperacion'] = this.idOperacion;
            body['XMLImpuestoLocal'] = '<propiedades></propiedades>'
            body['XMLInformacionAduanera'] = '<propiedades></propiedades>'
            this.srvcoal.postService(this.urlApi, body).subscribe((res: any) => {
              if (res.error == "") {
                this.arrayProcesadoErrors = [];
                this.msgErrorServidor = '';
                this.resultsets = res.recordsets[0];


              } else {
                this.arrayProcesadoErrors = res.recordsets[0];
                this.msgErrorServidor = res.message;
                this.resultsets = res.recordsets[0];
              }
            }, (error: any) => {
              console.log(error);

              this.msgErrorServidor = 'Ocurrió en error al procesar el archivo';
            });
          }
        });


      }
    }
  }


}
